export default __webpack_public_path__ + "static/el-b1511430aa72dec1ed77be9ca0dfc990.jpg";